import React from 'react';

import useForm from 'src/hooks/use-form';
import { doPost } from 'src/api';
import { InitialContactRequestValues } from 'src/constants';
import { getPhoneToApi } from 'src/utils';
import type { IContactRequest } from 'src/interfaces';

export default function useContactRequest(
  handleSubmit: () => void,
  handleError: (e?: any) => void,
  deceasedId: string = ''
) {
  const [isSending, setIsSending] = React.useState(false);

  const sendRequest = async (formObject: IContactRequest) => {
    const { name, phone, email, message, countryCode } = formObject;
    setIsSending(true);

    try {
      const result = await doPost('requests', {
        ...(deceasedId && { id: deceasedId }),
        name: name.trim(),
        phone: getPhoneToApi(phone, countryCode),
        email: email.trim(),
        message: message.trim(),
      });

      if (result) {
        handleSubmit();
      }
    } catch (e: any) {
      handleError(e.response?.data?.error);
    } finally {
      setIsSending(false);
    }
  };

  const {
    formFields,
    handleChange,
    handleSubmit: handleSubmitButtonClick,
  } = useForm<IContactRequest>(InitialContactRequestValues, sendRequest);

  return {
    handleChange,
    handleSubmitButtonClick,
    formObject: formFields,
    isSending,
  };
}
